import { MatDialogConfig } from '@angular/material/dialog';
import * as moment from 'moment';

export const InfoRegClientBarcodesMaxLength = 50;
export const WeightMin = 0.01;
export const WeightMax = 19000;
export const SeatsAmountMin = 1;
export const SeatsAmountMax = 999;
export const CostMin = 0.01;
export const CostMax = 11000000;
export const CostOnSiteMin = 0;
export const CostOnSiteMax = 11000000;
export const SenderContactPersonMaxLength = 150;
export const SenderRefMaxLength = 150;
export const RecipientRefMaxLength = 150;
export const CityMaxLength = 150;
export const WarehouseQueryMaxLength = 200;

export const CreationDateTimeMin = moment().subtract(1, 'month').toDate();
export const DeliveryDateTimeMin = moment().subtract(1, 'month').toDate();
export const DeliveryDateTimeMax = moment().add(1, 'month').toDate();
export const DateTimeMin = moment().subtract(1, 'month').toDate();
export const DateTimeMax = moment().add(1, 'month').toDate();
export const PreferredDeliveryDateMin = moment().subtract(1, 'month').toDate();
export const PreferredDeliveryDateMax = moment().add(2, 'months').toDate();
export const TodayDate = moment().toDate();

export const TableFilterSideSheetConfig: MatDialogConfig = {
  position: { right: '0' },
  width: '480px',
  maxWidth: '90vw',
  height: '100%',
  panelClass: 'setting-content-popup',
}
